import { MenuItem } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { OutcomesFormProps } from '~pages/Dialler/ConnectDialler/VoiceView/OutcomeCapture';

const OutcomesForm = ({ formSubmitting }: OutcomesFormProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Grid size={12}>
        Did you transfer your member to another department?<br></br>
        <Controller
          name='is_transfer'
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox {...field} id='is_transfer' disabled={formSubmitting} checked={field.value || false} />
              }
              label='Yes I transferred the member to another department'
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name='phone_number'
          control={control}
          defaultValue={''}
          rules={{
            validate: {
              regex: (value: string) => {
                const pattern = /^[0]\d{9}$/;
                return pattern.test(value) || 'Must be 10 digits numbers starting with 0 with no spaces. eg 0498765437';
              },
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='phone_number'
              label='Phone Number'
              disabled={formSubmitting}
              error={Boolean(errors.phone_number)}
              helperText={errors.phone_number?.message as string | undefined}
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name='member_id'
          control={control}
          defaultValue={''}
          rules={{
            required: 'Member ID is required',
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='member_id'
              label='Member ID'
              disabled={formSubmitting}
              error={Boolean(errors.member_id)}
              helperText={errors.member_id?.message as string | undefined}
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name='insurance_offered'
          control={control}
          defaultValue={''}
          rules={{
            required: 'Insurance offered is required',
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              select
              variant='outlined'
              id='insurance_offered'
              label='Life Insurance Introduced to Member'
              disabled={formSubmitting}
              error={Boolean(errors.insurance_offered)}
              helperText={errors.insurance_offered?.message as string | undefined}>
              <MenuItem value='no'>No</MenuItem>
              <MenuItem value='yes'>Yes</MenuItem>
              <MenuItem value='auth_not_provided'>Authorisation Not Provided</MenuItem>
            </TextField>
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name='insurance_outcome'
          control={control}
          defaultValue={''}
          rules={{
            required: 'Outcome is required',
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              select
              variant='outlined'
              id='insurance_outcome'
              label='Outcome'
              disabled={formSubmitting}
              error={Boolean(errors.insurance_outcome)}
              helperText={errors.insurance_outcome?.message as string | undefined}>
              <MenuItem value='not_applicable'>Not Applicable</MenuItem>
              <MenuItem value='sale'>Sale</MenuItem>
              <MenuItem value='declined'>Declined</MenuItem>
              <MenuItem value='information_sent'>Information Sent</MenuItem>
              <MenuItem value='callback'>Callback</MenuItem>
            </TextField>
          )}
        />
      </Grid>
    </>
  );
};

export default OutcomesForm;
